





















































import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

import BaseComponent from '@/components/base-component.vue';
import CollapsibleCard from '@/components/UI/collapsible-card.vue';
import UiDatePickerMultiple from '@/components/UI/date-picker-multiple.vue';

import UiCepFormat from '@/components/UI/cep-format.vue';
import UiDatePickerMultipleRange from '@/components/UI/date-picker-multi-range.vue';
import { dateFormat } from '@/helpers/dateFormat';
import { toNumber } from '@/helpers/toNumber';
import * as service from '@/services/prescription';
import * as moment from 'moment';
import { cepFormat } from '@/helpers/cepFormat';
@Component({
  components: {
    CollapsibleCard,
    UiDatePickerMultiple,
    UiDatePickerMultipleRange,
    UiCepFormat,
  },
})
export default class PrescriptionFormAddress extends BaseComponent {  
  @Prop()
  public item;
  @Prop()
  public disabled?: boolean;
  @Prop()
  public typesReady: boolean;
  @Prop()
  public presetDeliveryDates: [];
  @Prop({default: false})
  public deliveryDateDisabled: boolean;
  @Prop({default: false})
  public oneDeliveryDateOnly: boolean;



  keepAddressEnabled: boolean = false;

  public rules = {
    scheduling: [
      (value): boolean | string => !!value || 'Selecione pelo menos uma data de entrega',
      (value) => {
        if(value.length == 0)
           return 'Selecione pelo menos uma data de entrega';
        else{
          // value.array.forEach(element => {
            const schedulingUnix = toNumber(
              dateFormat(value, 'UNIX', 'DD/MM/YYYY'),
            );
            if (!moment(schedulingUnix).isValid()) {
              return 'Selecione pelo menos uma data de entrega válida';
            }
          // });
          return true;
        }
      },
    ],
    address: [(v) => (!!v && !!v.id) || 'Selecione um endereço de entrega'],
  };
  public addresses: any[] = [];
  public addressesLoading: boolean = false;
  public allowedDates = [];
  loadingDeliveryDates = false;

  @Watch('item.unidade')
  public onChangeItem(val: any): void {
    this.getDeliveryDates();
  }

  @Watch('typesReady')
  public onChangeTypesReady(val: boolean): void {
    if (val) {
      this.getDeliveryDates();
    }
  }

  @Watch('item.paciente')
  public onChangePatient(val: any): void {
    this.getAddresses();
  }

  @Watch('item.idTemplate')
  public onChangePattern(val: any): void {
  }

  @Watch('item.medico')
  public onChangeDoctor(val: any): void {
    this.getDeliveryDates();
  }

  @Watch('item.bolsaMulticompart')
  public onChangeMultiCompart(val: any): void {
    this.getAddresses();
    this.getDeliveryDates();
  }

  @Watch('item.endereco')
  public onChangeAddress(val: any): void {
    this.getDeliveryDates();
  }
 
  @Watch('item.idPrescricaoCopia')
  public onChangeIdPrescricaoCopia(val: any): void {
    this.getAddresses();
    this.getDeliveryDates();
  }

  public onChangeSchedulingDate(val): void {
    this.$emit('changeSchedulingDate', val);
  }

  public onFilter(item: any, queryText: string, itemText: any): boolean {
    const query = queryText.toLowerCase();

    return (
      !query ||
      (item.descricao.toLowerCase().indexOf(query) !== -1 ||
        item.logradouro.toLowerCase().indexOf(query) !== -1 ||
        item.municipio.toLowerCase().indexOf(query) !== -1 ||
        item.estado.toLowerCase().indexOf(query) !== -1 ||
        item.cep.toLowerCase().indexOf(query) !== -1)
    );
  }

  public dateIsDisabled(): boolean {
    return this.item.isVisualization() || this.deliveryDateDisabled;
  }

  private getAddresses(): void {
    this.addresses = [];
    if (
      !this.item.paciente ||
      !this.item.paciente.id ||
      !this.item.unidade ||
      !this.item.unidade.id
    ) {
      return;
    }

    if (!!this.item.isVisualization()) {
      this.addresses = !!this.item.endereco ? [this.item.endereco] : [];
    } else {
      const currentAddress = this.item.endereco;
      this.item.endereco = null;
      this.addressesLoading = true;

      const setAddress = (data) => {
        this.addresses = data;
        this.addressesLoading = false;
        let enderecoOrigemAlterado = !!currentAddress && currentAddress.origemAlterado;

        // se o endereço origem foi alterado, não escolher esse endereço, a não ser que seja a unica opção
        if (!!currentAddress && !currentAddress.origemAlterado) {
          this.item.endereco = this.addresses.find(
            (address) => address.id === currentAddress.idEnderecoOrigem,
          );
        }
        if (this.addresses.length == 1) {
            this.item.endereco = this.addresses[0];
        }

        // se o endereço origem foi alterado e tem mais de uma opção para escolha, manter o combo liberado para escolha
        // independente de ser copia fiel ou não
        this.keepAddressEnabled = enderecoOrigemAlterado && this.addresses.length > 1;
      };

      service
        .getAddressesPatient(this.item.paciente.id, this.item.unidade.id, this.item.bolsaMulticompart)
        .subscribe(
          (data) => {
              setAddress(data);
          },
          () => {
            this.addressesLoading = false;
          },
        );
    }
  }

  private getDeliveryDates() {
    if (this.item.isVisualization() || !this.item.unidade || !this.item.unidade.id || !this.item.medico || !this.item.medico.id || !this.item.endereco || !this.item.endereco.id ) {
      return;
    }
    if (this.presetDeliveryDates && this.presetDeliveryDates.length) {
      this.item.dataPrescricao = Object.assign(new Array(), this.presetDeliveryDates);
      if (this.deliveryDateDisabled) {
        this.allowedDates = Object.assign(new Array(), this.presetDeliveryDates);
        this.onChangeSchedulingDate(this.item.dataPrescricao);
        return;
      }
    }
    this.loadingDeliveryDates = true;
    service.listDeliveryDates(this.item.unidade.id, this.item.medico.id, this.item.endereco.id, this.item.bolsaMulticompart).subscribe(res => {
      this.loadingDeliveryDates = false;
      this.allowedDates = res;
      if (!this.item.dataPrescricao || !this.allowedDates.find(d => d == this.item.dataPrescricao)) {
        this.item.dataPrescricao = [this.allowedDates[0]];
      }

      // quando é prescrição cópia de bolsa multi, não sugerir data de entrega. O usuário deve escolher.
      if (this.item.idPrescricaoCopia && this.item.bolsaMulticompart) {
        this.item.dataPrescricao = [];
      } 
      this.onChangeSchedulingDate(this.item.dataPrescricao);
    });
  }

  getAddressDescription(address) {
    return `${address.descricao} - ${cepFormat(address.cep)} - ${address.logradouro}`;
  }
  
}
